import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';

@Injectable()
export class UnsecuredService {

  constructor(private http: HttpClient, private baseService: BaseService) {
  }

  sendContactUs(data) {
    return this.http.post('/accounts/public/contact', data);
  }
}
